import { createFileRoute } from '@tanstack/react-router';
import { FormEditorTab } from '@web/modules/forms/editor/form-editor-tab';

export const Route = createFileRoute('/_app/capture/forms/$formId/')({
  component: FormEditorTab,
});
